module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-ucat"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__ucat"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "logo",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/upcloseandtasty_logo.jpg"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row-button"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('link-button', {
    attrs: {
      "url": "http://upcloseandtasty.com",
      "text": "visit the website"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "case-study__full-screenshot"
  }, [_c('img', {
    ref: "bg1",
    staticClass: "case-study__full-screenshot__bg",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/screen-bg.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    ref: "main",
    staticClass: "case-study__full-screenshot__img case-study__row case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/2017-07-06-21-40-upcloseandtasty.com.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "smores",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/smores_popsicles_upcloseandtasty_07b.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__full-screenshot"
  }, [_c('img', {
    ref: "bg2",
    staticClass: "case-study__full-screenshot__bg",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/screen-bg.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    ref: "main2",
    staticClass: "case-study__full-screenshot__img case-study__row case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/2017-07-06-21-46-upcloseandtasty.com.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n          Up Close & Tasty\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Freelance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Development"), _c('br'), _vm._v("Consulting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("11/2016 - Present")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n                Up Close & Tasty is a food photography blog powered by the WordPress platform. I assisted the owner in migrating the blog from Squarespace to WordPress, and have been implementing various custom stylistic and functional tweaks across the site in order to improve and smoothen its user experience.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• JavaScript")]), _vm._v(" "), _c('li', [_vm._v("• HTML")]), _vm._v(" "), _c('li', [_vm._v("• CSS")]), _vm._v(" "), _c('li', [_vm._v("• PHP")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dce0252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UCAT.vue
// module id = 179
// module chunks = 1